<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2>
        <v-card-text>
          <v-container>
            <div class="success-page">
              <h1>🎉 Order placed!</h1>
              <p>
                Thanks — your order is in the system and will ship to the address you provided.
              </p>
              <v-btn color="#388b9d" dark large to="/store">Back to store</v-btn>
              <v-btn class="ml-2" outlined to="/">My dashboard</v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { clearCart } from '@/utils/store'
export default {
  created () {
    this.$store.commit('setLayout', 'iabf-layout')
    // Stripe will redirect here after payment — clear the local cart so the
    // dancer doesn't see stale items.
    clearCart()
  }
}
</script>

<style scoped>
.success-page { text-align: center; padding: 60px 20px; }
h1 { font-family: var(--iabf-font-display, Georgia, serif); font-weight: 400; font-size: 36px; margin-bottom: 16px; }
p { font-family: var(--iabf-font-body, inherit); font-size: 17px; color: #555; margin-bottom: 24px; max-width: 500px; margin-left: auto; margin-right: auto; }
</style>
